import {
  Button,
  Chip,
  CircularProgress,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import CheckoutIcon from '@mui/icons-material/ContentCopy'
import Hosts from '../../core/functions/hosts'

interface CeletusClubSyncStatusProps {
  friendlyId?: string | null
  loading: boolean
  onRetry: () => void
}

export function CeletusClubSyncStatus({
  friendlyId,
  loading,
  onRetry,
}: CeletusClubSyncStatusProps) {
  const [copied, setCopied] = useState(false)

  if (friendlyId) {
    return (
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <TextField
            fullWidth
            size="small"
            label="ID no Celetus Club"
            value={friendlyId}
            disabled
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() =>
                      Hosts.copyTextToClipboard(friendlyId).then(() =>
                        setCopied(true)
                      )
                    }
                    edge="end"
                  >
                    <CheckoutIcon sx={{ fontSize: '1.2rem' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Chip label="Sincronizado" color="success" size="small" />
        </Stack>
        {copied && (
          <Typography variant="caption" color="success.main">
            ID copiado!
          </Typography>
        )}
      </Stack>
    )
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Chip label="Aguardando sincronização" color="warning" size="small" />
      <Button
        variant="outlined"
        size="small"
        disabled={loading}
        onClick={onRetry}
        startIcon={loading ? <CircularProgress size={14} /> : undefined}
      >
        {loading ? 'Sincronizando...' : 'Tentar sincronizar novamente'}
      </Button>
    </Stack>
  )
}
